import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

/**
 * بقى مفيش أي توكن ولا مفتاح مطلوب خالص من الفرونت اند.
 * الباك اند بقى بيسجل كل الطلبات الجايه على connector/api/* تلقائياً
 * بحساب الموقع الثابت (شوف middleware: ConnectorAutoAuth).
 */
const baseQuery = fetchBaseQuery({
  baseUrl: "https://test.prosofteg.com/",
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    return headers;
  },
});

/**
 * إعداد API Slice
 */
export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery,
  tagTypes: ["Product", "Products", "Token", "Categories"],

  endpoints: (builder) => ({
    // ==================== المستخدم ====================
    login: builder.mutation({
      query: (credentials) => ({
        url: "connector/api/user/login",
        method: "POST",
        body: credentials,
      }),
    }),
    register: builder.mutation({
      query: (newUser) => ({
        url: "connector/api/user-registration",
        method: "POST",
        body: newUser,
      }),
    }),
    // sliders
    GetSlider: builder.mutation({
      query: () => ({
        url: "connector/api/slide",
        method: "POST",
        body: {},
      }),
    }),

    // جلب جميع المنتجات
    getAllProducts: builder.query({
      query: ({ page = 1, per_page = 50 } = {}) =>
        `connector/api/product?page=${page}&per_page=${per_page}`,
      providesTags: ["Product"],
    }),

    //  جلب جميع المنتجات المميزه
    getFeatureProducts: builder.query({
      query: (page = 1) => `connector/api/feature_product?page=${page}`,
    }),

    // بحث عن المنتجات
    searchProducts: builder.query({
      query: (searchTerm) =>
        `connector/api/product/?query=${encodeURIComponent(searchTerm)}`,
    }),
    // جلب جميع المناطق
    getGovernorate: builder.query({
      query: () => "connector/api/governorate",
    }),
    // انشاء اوردر من عربة التسوق
    CreateOrderFromCart: builder.mutation({
      query: (cartData) => ({
        url: "connector/api/neworder",
        method: "POST",
        body: cartData,
      }),
    }),

    // ==================== الطلبات ====================
    getOrdersByContactId: builder.mutation({
      query: ({ contactId, page = 1, per_page = 50 }) => ({
        url: `connector/api/getorders/${contactId}`,
        method: "POST",
        body: { page, per_page },
      }),
    }),
    getOrderById: builder.mutation({
      query: (orderId) => ({
        url: `connector/api/getorder/${orderId}`,
        method: "POST",
        body: {},
      }),
    }),
    // جلب منتج واحد حسب ID
    getOneProduct: builder.query({
      query: (id) => `connector/api/product/${id}`,
      providesTags: (result, error, id) => [{ type: "Products", id }],
    }),

    // ==================== التصنيفات ====================
    getCategories: builder.query({
      query: () => "connector/api/categories",
      providesTags: ["Categories"],
    }),

    getCategorieById: builder.query({
      query: ({ id, per_page = 500 } = {}) =>
        `connector/api/categories/${id}?per_page=${per_page}`,
      providesTags: ["Categories"],
    }),

    getCategorieByIdPaged: builder.query({
      query: ({ id, page = 1, per_page = 50 } = {}) =>
        `connector/api/categories/${id}?page=${page}&per_page=${per_page}`,
      providesTags: ["Categories"],
    }),

    // ==================== علامه تجاريه ====================
    getBrands: builder.query({
      query: () => "connector/api/brand",
      providesTags: ["Brands"],
    }),

    getBrandById: builder.query({
      query: (id) => `connector/api/brand/${id}`,
      providesTags: ["Brands"],
    }),

    // ==================== تغيير كلمة المرور ====================
    updatePassword: builder.mutation({
      query: (credentials) => ({
        url: "connector/api/update-password",
        method: "POST",
        body: credentials,
      }),
    }),

    // ==================== تحديث العنوان ====================
    updateAddress: builder.mutation({
      query: (data) => ({
        url: "connector/api/update-address",
        method: "POST",
        body: data,
      }),
    }),

    // ==================== الشريط المتحرك ====================
    getTicker: builder.query({
      query: () => "connector/api/ticker",
    }),

    // ==================== مواعيد العمل ====================
    getWorkHours: builder.query({
      query: () => "connector/api/work-hours",
      keepUnusedDataFor: 60,
    }),

    // ==================== ترتيب أقسام الصفحة الرئيسية ====================
    getHomeSections: builder.query({
      query: () => "connector/api/home-sections",
      keepUnusedDataFor: 120,
    }),

    // ==================== الاجازات ====================
    Vacations: builder.mutation({
      query: () => ({
        url: "connector/api/vacations",
        method: "POST",
      }),
      invalidatesTags: ["Vacations"],
    }),
  }),
});

// استخراج الـ hooks
export const {
  useLoginMutation,
  useRegisterMutation,
  useGetSliderMutation,
  useGetAllProductsQuery,
  useSearchProductsQuery,
  useGetFeatureProductsQuery,
  useGetCategoriesQuery,
  useGetCategorieByIdQuery,
  useGetCategorieByIdPagedQuery,
  useGetBrandsQuery,
  useGetBrandByIdQuery,
  useGetOneProductQuery,
  useGetGovernorateQuery,
  useCreateOrderFromCartMutation,
  useGetOrderByIdMutation,
  useGetOrdersByContactIdMutation,
  useVacationsMutation,
  useUpdatePasswordMutation,
  useUpdateAddressMutation,
  useGetTickerQuery,
  useGetWorkHoursQuery,
  useGetHomeSectionsQuery,
} = apiSlice;

// خلاص مبقاش فيه توكن نتأكد منه وقت فتح الموقع، فالدالة دي بقت no-op
// (سايبينها موجودة عشان مانعملش تعديل في index.tsx)
export const initializeToken = async () => {
  return Promise.resolve();
};
